import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface NotificationStep {
    tabLabel: string;
    tabIcon?: string;
    description: string;
    bullets: string[];
    featureBullets?: NotificationFeatureBullet[];
    highlights?: string[];
    coverageGroups?: NotificationCoverageGroup[];
    tip?: string;
    tipVariant?: 'warning' | 'info';
    tipIcon?: string;
    examples: string[];
}

export interface NotificationFeatureBullet {
    lead: string;
    text: string;
}

export interface NotificationCoverageGroup {
    label: string;
    icon?: string;
    items: string[];
}

export interface NotificationData {
    heading: string;
    subHeading: string;
    steps: NotificationStep[];
}

@Component({
    selector: 'notification-snackbar',
    templateUrl: './notification-snackbar.component.html',
    styleUrls: ['./notification-snackbar.component.scss'],
    standalone: false
})
export class NotificationSnackbarComponent {
    public stepIndex: number = 0;

    constructor(
        private snackBarRef: MatSnackBarRef<NotificationSnackbarComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: NotificationData,
    ) { }

    public get currentStep(): NotificationStep {
        return this.data.steps[this.stepIndex];
    }

    public get isLastStep(): boolean {
        return this.stepIndex === this.data.steps.length - 1;
    }

    public selectStep(index: number): void {
        if (index < 0 || index >= this.data.steps.length) {
            return;
        }

        this.stepIndex = index;
    }

    public next(): void {
        if (!this.isLastStep) {
            this.stepIndex++;
        }
    }

    public getStarted(): void {
        this.snackBarRef.dismissWithAction();
    }
}
